const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`, `f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`, 1, 101), undefined, true, false, 1));
            }

            getTemplateName() {
                return `f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`;
            }

            getSourceContext() {
                return new this.Source(``, `f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`, ``);
            }
        }],
        [101, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`, `f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`, 3, 100), undefined, true, false, 3));
                this.echo(`  `);
            }

            getTemplateName() {
                return `f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`, ``);
            }
        }],
        [100, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/logo-group/logo-group.twig`, `f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`, 3);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/logo-group/logo-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`items`) ? context.get(`items`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`          <img src="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(6, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 6, this.source)(this.env, context.get(`item`), `src`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`" alt="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(6, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 6, this.source)(this.env, context.get(`item`), `alt`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">
        `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`      `);
            }

            getTemplateName() {
                return `f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f');

let template = env.loadTemplate('f04549255c57431a6908453c6123b5770079cfc629b70622af0d997a711b054f');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/logo-group/demo/demo.twig", args: context }
     );
     return rendered;;
};